import { useEffect, useRef, useState, type RefObject } from "react";

const useOnScreen = (
  ref: RefObject<Element | null>,
  options?: IntersectionObserverInit,
  initial = true,
) => {
  const [isIntersecting, setIntersecting] = useState(initial);
  const hasIntersectedOnce = useRef(false);

  useEffect(() => {
      if (ref?.current) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          hasIntersectedOnce.current = true;
        }
        if (hasIntersectedOnce.current) {
          setIntersecting(entry.isIntersecting);
        }
      }, options);

      observer.observe(ref.current);
      return () => {
        observer.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options/ref intentionally omitted, callers pass stable literals / memoized objects
  }, []);

  return isIntersecting;
};

export default useOnScreen;
